"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotificationEmailIsSetup = exports.getNotificationEmailIsEnabled = exports.getStagedEmailObject = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reselect = require("reselect");

var _constants = require("settings-ui-sdk/BlogNotificationEmails/constants");

var _NotificationEmailSettings = require("../../stagedObjects/NotificationEmailSettings");

var _STAGED_NOTIFICATION_;

var STAGED_NOTIFICATION_EMAILS = (_STAGED_NOTIFICATION_ = {}, (0, _defineProperty2.default)(_STAGED_NOTIFICATION_, _constants.INSTANT_EMAIL, _NotificationEmailSettings.InstantNotificationEmailSettings), (0, _defineProperty2.default)(_STAGED_NOTIFICATION_, _constants.DAILY_EMAIL, _NotificationEmailSettings.DailyNotificationEmailSettings), (0, _defineProperty2.default)(_STAGED_NOTIFICATION_, _constants.WEEKLY_EMAIL, _NotificationEmailSettings.WeeklyNotificationEmailSettings), (0, _defineProperty2.default)(_STAGED_NOTIFICATION_, _constants.MONTHLY_EMAIL, _NotificationEmailSettings.MonthlyNotificationEmailSettings), _STAGED_NOTIFICATION_);

var getStagedEmailObject = function getStagedEmailObject(emailType) {
  return STAGED_NOTIFICATION_EMAILS[emailType];
};

exports.getStagedEmailObject = getStagedEmailObject;

var getNotificationEmailIsEnabled = function getNotificationEmailIsEnabled(emailType) {
  return (0, _reselect.createSelector)([getStagedEmailObject(emailType).getStagedProperty(_constants.ENABLED)], function (isEnabled) {
    return isEnabled;
  });
};

exports.getNotificationEmailIsEnabled = getNotificationEmailIsEnabled;

var getNotificationEmailIsSetup = function getNotificationEmailIsSetup(emailType) {
  return (0, _reselect.createSelector)([getStagedEmailObject(emailType).getStagedProperty(_constants.ID), getStagedEmailObject(emailType).getStagedProperty(_constants.REPLY_TO), getStagedEmailObject(emailType).getStagedProperty(_constants.FROM_NAME)], function (id, replyTo, fromName) {
    return Boolean(id) && Boolean(replyTo) && Boolean(fromName);
  });
};

exports.getNotificationEmailIsSetup = getNotificationEmailIsSetup;